
import RefreshLeftSquare from "../../../assets/outline/RefreshLeftSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RefreshLeftSquareIcon({ className, dataTestid = "RefreshLeftSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RefreshLeftSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
